import { ThemeProvider } from '@mui/material';
import React, { ReactNode } from 'react';
import { useDynamicBrand } from 'src/context/DynamicBrandContext';

import { useAppSelector } from '../../../hooks/hooks';
import { themeCreator } from '../base';
import { selectTheme } from '../store/theme/themeSlice';
import { createDynamicTheme } from '../utils/createDynamicTheme';

export const ThemeContext = React.createContext(
  (themeName: string): void => {}
);

interface IThemeProviderWrapper {
  children: ReactNode;
}

const ThemeProviderWrapper: React.FC<IThemeProviderWrapper> = (props: any) => {
  const curThemeName = useAppSelector(selectTheme);
  const { config, isActive } = useDynamicBrand();

  const baseTheme = themeCreator(curThemeName);
  const theme = isActive ? createDynamicTheme(baseTheme, config) : baseTheme;

  return <ThemeProvider theme={theme}>{props.children}</ThemeProvider>;
};

export default ThemeProviderWrapper;
